/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Retake_PreparingInputs */

const en_us2_body_assessment_retake_preparing = /** @type {(inputs: Body_Assessment_Retake_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting the photo you're keeping…`)
};

const pt_br2_body_assessment_retake_preparing = /** @type {(inputs: Body_Assessment_Retake_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separando a foto que continua valendo…`)
};

const es_419_body_assessment_retake_preparing = /** @type {(inputs: Body_Assessment_Retake_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando la foto que se queda…`)
};

const pt_pt2_body_assessment_retake_preparing = /** @type {(inputs: Body_Assessment_Retake_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A separar a foto que continua a valer…`)
};

const fr_fr2_body_assessment_retake_preparing = /** @type {(inputs: Body_Assessment_Retake_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération de la photo conservée…`)
};

const de_de2_body_assessment_retake_preparing = /** @type {(inputs: Body_Assessment_Retake_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Foto, das bleibt, wird geladen…`)
};

const it_it2_body_assessment_retake_preparing = /** @type {(inputs: Body_Assessment_Retake_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero della foto che resta valida…`)
};

/**
* | output |
* | --- |
* | "Getting the photo you're keeping…" |
*
* @param {Body_Assessment_Retake_PreparingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_retake_preparing = /** @type {((inputs?: Body_Assessment_Retake_PreparingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Retake_PreparingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_retake_preparing(inputs)
	if (locale === "es-419") return es_419_body_assessment_retake_preparing(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_retake_preparing(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_retake_preparing(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_retake_preparing(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_retake_preparing(inputs)
	return en_us2_body_assessment_retake_preparing(inputs)
});
export { body_assessment_retake_preparing as "body-assessment.retake_preparing" }